import type { Template } from "@amzn/d16-g-cdb-publisher-portal-typescript-client";
import { RadioButton, Tag } from "@amzn/storm-ui";
import React from "react";
import styled from "styled-components";

const TemplateSelectorContainer = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
`;

export interface TemplateSelectorProps {
    template: Template;
    disabled?: boolean;
    templateIdentifier: string;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const TemplateSelector: React.FunctionComponent<
    TemplateSelectorProps
> = ({ template, disabled, templateIdentifier, handleChange }) => {
    return (
        <TemplateSelectorContainer data-testid={`template-${template.id}`}>
            <RadioButton
                data-testid={`template-radio-button-${template.id}`}
                id={`template-radio-button-${template.id}`}
                label={template.name}
                value={template.id}
                isChecked={template.id === templateIdentifier}
                disabled={disabled}
                onChange={handleChange}
            />
            {disabled && <Tag variant="beta" label="disabled" />}
        </TemplateSelectorContainer>
    );
};
